import detectMobile from './detect-mobile';
import getComputedCss from './get-computed-css';

/* eslint-disable no-magic-numbers */
const SIZES = [
    ['phone', 430],
    ['tablet', 800],
    ['desktop', 1600],
    ['wide', Infinity],
];

export const getScreenInfo = (mode = 'auto') => {
    const getSize = (currentWidth) => SIZES[SIZES.findIndex(([name, width]) => currentWidth <= width)][0];
    const hasMetaViewPortTag = () => Boolean(document.querySelector('meta[name="viewport"]'));

    return {
        get width() {
            return Math.min(
                window.innerWidth,
                window.screen.width,
                document.documentElement.clientWidth,
                document.body.offsetWidth,
                document.body.clientWidth,
            );
        },
        get device() {
            return getSize(this.width);
        },
        get pageFontSize() {
            return parseInt(getComputedCss(document.body, 'font-size').replace('px', ''));
        },
        isMobile: setMobileInfo(mode),
        isResponsive: hasMetaViewPortTag(),
    };
};

export const setMobileInfo = (mode) => {
    switch (mode) {
    case 'auto':
        return detectMobile();
    case 'mobile':
        return true;
    case 'web':
        return false;
    }
};

export default getScreenInfo;
